import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';

import { HomePage } from './home';
import { EventoProvider } from '../../providers/evento/evento.provider';

@NgModule({
  declarations: [
    HomePage,
  ],
  imports: [
    IonicPageModule.forChild(HomePage),
    TranslateModule.forChild()
  ],
  exports: [
    HomePage
  ],
  providers: [
    EventoProvider
  ]
})
export class HomePageModule { }


// WEBPACK FOOTER //
// ./src/pages/home/home.module.ts